export interface ClientInterface {
  id: string;
  caseId?: string;
  aliasName?: string;
  dateOfBirth?: string;
  email?: string;
  ethnicity?: string;
  firstName: string;
  lastName: string;
  legalGuardian?: string;
  phoneNumber?: string;
  sex: string;
  ssn?: string;
  createdAt: string;
  updatedAt: string;
  externalId?: string;
  locationId: string;
  referralSourceId?: string;
  program?: string | { id: string; name: string };
  assignedTo?: string;
  status: string;
  referralSource?: string | { id: string; name: string };
  payers?: Array<{ id: string; name: string }>;
  location?: string | { id: string; name: string };
  avatar?: any;
  avatarUrl?: string;
  picture?: File | null;
  pictureUrl?: string;
  removePicture?: boolean;
  clientInsurances?: any[];
  clientInsurancesAttributes?: any[];
}

export class Client implements ClientInterface {
  id: string;
  caseId?: string;
  aliasName?: string;
  dateOfBirth?: string;
  email?: string;
  ethnicity?: string;
  firstName: string;
  lastName: string;
  legalGuardian?: string;
  phoneNumber?: string;
  sex: string;
  ssn?: string;
  createdAt: string;
  updatedAt: string;
  externalId?: string;
  locationId: string;
  referralSourceId?: string;
  program?: string | { id: string; name: string };
  assignedTo?: string;
  status: string;
  referralSource?: string | { id: string; name: string };
  payers?: Array<{ id: string; name: string }>;
  location?: string | { id: string; name: string };
  avatar?: any;
  avatarUrl?: string;
  picture?: File | null;
  pictureUrl?: string;
  removePicture?: boolean;
  clientInsurances?: any[];

  constructor(data: Partial<ClientInterface>) {
    this.id = data.id!;
    this.caseId = data.caseId;
    this.aliasName = data.aliasName;
    this.dateOfBirth = data.dateOfBirth;
    this.email = data.email;
    this.ethnicity = data.ethnicity;
    this.firstName = data.firstName!;
    this.lastName = data.lastName!;
    this.legalGuardian = data.legalGuardian;
    this.phoneNumber = data.phoneNumber;
    this.sex = data.sex || '';
    this.ssn = data.ssn;
    this.createdAt = data.createdAt!;
    this.updatedAt = data.updatedAt!;
    this.externalId = data.externalId;
    this.locationId = data.locationId!;
    this.referralSourceId = data.referralSourceId;
    this.program = data.program;
    this.assignedTo = data.assignedTo;
    this.status = data.status!;
    this.referralSource = data.referralSource;
    this.payers = data.payers;
    this.location = data.location;
    this.avatar = data.avatar || '';
    this.avatarUrl = data.avatarUrl || '';
    this.picture = data.picture || null;
    this.pictureUrl = data.pictureUrl || '';
    this.removePicture = data.removePicture || false;
    this.clientInsurances = data.clientInsurances || [];
  }

  toJson(): ClientInterface {
    console.log('client.toJson', this.clientInsurances);
    return {
      id: this.id,
      caseId: this.caseId,
      aliasName: this.aliasName,
      dateOfBirth: this.dateOfBirth,
      email: this.email,
      ethnicity: this.ethnicity,
      firstName: this.firstName,
      lastName: this.lastName,
      legalGuardian: this.legalGuardian,
      phoneNumber: this.phoneNumber,
      sex: this.sex?.toLowerCase() || '',
      ssn: this.ssn,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      externalId: this.externalId,
      locationId: this.locationId,
      referralSourceId: this.referralSourceId,
      program: this.program,
      assignedTo: this.assignedTo,
      status: this.status?.toLowerCase(),
      referralSource: this.referralSource,
      payers: this.payers,
      location: this.location,
      picture: this.picture,
      removePicture: this.removePicture,
      clientInsurancesAttributes:
        this.clientInsurances?.map(insurance => ({
          id: insurance.id || null,
          payer_id: insurance.payerId,
          insurance_type: insurance.insuranceType,
          as_of_date: insurance.asOfDate,
                 until_date: insurance.untilDate,
                 policy_holder: insurance.policyHolder,
                 policy_number: insurance.policyNumber,
                 group_number: insurance.groupNumber,
                 plan_year: insurance.planYear,
          _destroy: false,
        })) || [],
    };
  }
}
